import React from "react";
import styled from "styled-components";
import { Tooltip } from "./Tooltip";

const Styles = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  .text-field {
    z-index: 3;
    width: calc(100% - 2rem);
    padding: calc(var(--fs-textfield) * 2.3) calc(var(--fs-textfield) * 1.5) calc(var(--fs-textfield) * 0.7);
    border-radius: var(--border-radius);
    border: none;
    outline: none;
    transition: var(--trans-1);
    font-size: var(--fs-textfield);
    background: transparent;
    &.error-text {
      border: 1px var(--secondry-1) solid;
    }
    &.ltr-text {
      text-align: left;
      direction: ltr;
    }
    &.center-text {
      text-align: center;
      direction: ltr;
    }
    :focus {
      border: 1px var(--border-3) solid;
    }
  }
  .eye {
    cursor: pointer;
    position: absolute;
    z-index: 5;
    top: calc(var(--fs-textfield) * 1.5);
    left: calc(var(--fs-textfield) * 1.5);
  }
  .label-textinput{
    z-index: 2;
    position: absolute;
    top: calc(var(--fs-textfield) * 1.5);
    left: calc(var(--fs-textfield) * 1.5);
    transition: var(--trans-1);
  }
  .text-field:focus + .label-textinput {
    z-index: 5;
    top: calc(var(--fs-textfield) * 0.5);
    font-size: calc(var(--fs-textfield) * 0.8);
  }
  .text-field:not([value=""]) + .label-textinput {
    z-index: 5;
    top: calc(var(--fs-textfield) * 0.5);
    font-size: calc(var(--fs-textfield) * 0.8);
  }
  .help-input{
    z-index: 5;
    position: absolute;
    top: calc(var(--fs-textfield) * 1.35);
    right: calc(var(--fs-textfield) * 1.5);
    transition: var(--trans-1);
    .icon {
      width: 24px;
      transition: var(--trans-1);
    }
    &.password {
      right: calc(var(--fs-textfield) * 3.5);
    }
    .helpText{
      z-index: 5;
    }
  }
  .help-pass {
    padding: 0.3rem 0.3rem 0;
    font-size: var(--fs-small);
  }
  .error {
    display: flex;
    height: 0.75rem;
    font-size: var(--fs-small);
    .icon {
      width: 1rem;
      height: 1rem;
    }
    .text {
      margin: 0.1rem 0.2rem 0 0;
      color: red;
    }
  }
  @media screen and (max-width: 1445px) {
    .text-field {
      padding: calc(var(--fs-textfield) * 1.6) calc(var(--fs-textfield) * 1.05) calc(var(--fs-textfield) * 0.5);
    }
    .eye {
      top: calc(var(--fs-textfield) * 1.05);
      left: calc(var(--fs-textfield) * 1.05);
    }
    .label-textinput{
      top: calc(var(--fs-textfield) * 1.05);
      left: calc(var(--fs-textfield) * 1.05);
    }
    .text-field:focus + .label-textinput {
      top: calc(var(--fs-textfield) * 0.3);
      font-size: calc(var(--fs-textfield) * 0.8);
    }
    .text-field:not([value=""]) + .label-textinput {
      top: calc(var(--fs-textfield) * 0.3);
      font-size: calc(var(--fs-textfield) * 0.8);
    }
    .help-input{
      top: calc(var(--fs-textfield) * 0.95);
      right: calc(var(--fs-textfield) * 1.05);
    }
  }
`;

// dokme chesm baray ramz ha
export const TextInputWTitleDisable = ({
  style,
  value,
  title,
  ltr,
  center,
  help,
}) => {
  let classes = 'text-field';
  if (ltr) {
    classes += " ltr-text";
  }

  if (center) {
    classes += " center-text";
  }
  //
  
  let helpElement = '';
  if(help) {
    helpElement = (
      <Tooltip ClassTooltip={"help-input"} ClassText={'helpText'} width="15rem" right={'-7.5rem'}>
        {help}
      </Tooltip>
    );
  }

  return (
    <Styles style={style}>
      <input
        className={classes}
        type={"text"}
        value={value}
        disabled="true"
      />
      <label className="label-textinput">
        {title}
      </label>
      {helpElement}
    </Styles>
  );
};
